import { Box } from "@outschool/backpack";
import { HeroLayoutVariableWidth } from "@outschool/ui-components-classroom";
import React from "react";

import Footer from "../../layout/nav/Footer";
import Header from "../../layout/nav/Header";

export function AvatarBuilderHeroLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <HeroLayoutVariableWidth
      header={<Header includeBlob />}
      footer={<Footer />}
    >
      <Box sx={{ maxWidth: "1600px", marginX: "auto" }}>{children}</Box>
    </HeroLayoutVariableWidth>
  );
}
